import styled from "styled-components";
import { device } from "../../devices.js";

const MyAccountAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.backgrounds.mainBG};
  padding: 2rem 1.5rem 1rem 1.5rem;
  font-family: ${props => props.theme.typography.fontFamily};
  min-height: 100%;
  @media ${device.mobileScreen} {
    padding: 0 1.5rem 0 1.5rem;
  }
`;

const MyAccountAreaMenuComponents = styled.div`
  flex-grow: 1;
`;

export { MyAccountAreaWrapper, MyAccountAreaMenuComponents };
